/**
 * Export an array of flat objects to a CSV file download.
 * @param {Array<{key: string, title: string}>} columns - column definitions
 * @param {Array<Object>} rows - data rows
 * @param {string} filename - filename without extension
 */
export const exportCSV = (columns, rows, filename = "export") => {
  const header = columns.map((c) => `"${String(c.title ?? c.key).replace(/"/g, '""')}"`).join(",");
  const body = rows.map((row) =>
    columns
      .map((c) => {
        const raw = c.key ? row[c.key] : row[c.dataIndex ?? ""];
        const val = raw === null || raw === undefined ? "" : String(raw);
        return `"${val.replace(/"/g, '""')}"`;
      })
      .join(",")
  );
  const csv = [header, ...body].join("\r\n");
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
